import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from './ui/alert-dialog';

export default function ConfirmDialog({ 
    open, 
    onOpenChange, 
    title, 
    description, 
    confirmText = "Conferma", 
    cancelText = "Annulla",
    onConfirm,
    variant = "default" // "default" | "destructive"
}) {
    const handleConfirm = () => {
        onConfirm();
        onOpenChange(false);
    };

    return (
        <AlertDialog open={open} onOpenChange={onOpenChange} modal={true}>
            <AlertDialogContent 
                className="bg-[#0A0A0A] border border-white/20"
                onPointerDownOutside={(e) => e.preventDefault()}
                onInteractOutside={(e) => e.preventDefault()}
            >
                <AlertDialogHeader>
                    <AlertDialogTitle className="text-white">
                        {title}
                    </AlertDialogTitle>
                    <AlertDialogDescription className="text-white/60">
                        {description}
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel 
                        className="bg-transparent border-white/20 text-white hover:bg-white/10 hover:text-white"
                    >
                        {cancelText}
                    </AlertDialogCancel>
                    <AlertDialogAction
                        onClick={handleConfirm}
                        className={variant === "destructive" 
                            ? "bg-red-500 text-white hover:bg-red-600" 
                            : "bg-[#00FF41] text-black hover:bg-[#00CC33]"
                        }
                    >
                        {confirmText}
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}
